import { useEffect, useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/auth/AuthContext";
import './login.css';
import logoDefault from '../../assets/images/default/logo_beepay.png'

const LoginCallback = () => {
    const navigate = useNavigate();
    const { loginWithOracleCode } = useContext(AuthContext);

    const [logoUrl, setLogoUrl] = useState<string>(logoDefault);

    const processedRef = useRef(false);



    useEffect(() => {

        if (processedRef.current) {
            return;
        }

        processedRef.current = true;

        const processLogin = async () => {
            try {

                const params = new URLSearchParams(window.location.search);

                const code = params.get("code");
                const returnedState = params.get("state");
                const error = params.get("error");

                if (error) {
                    console.error("Oracle Error:", error);
                    navigate("/login", { replace: true });
                    return;
                }

                if (!code) {
                    console.error("Authorization code not found");
                    navigate("/login", { replace: true });
                    return;
                }

                const savedState = sessionStorage.getItem("oauth_state");

                if (savedState !== returnedState) {
                    console.error("Invalid state");
                    navigate("/login", { replace: true });
                    return;
                }

                const success = await loginWithOracleCode(code);

                if (!success) {
                    navigate("/login", { replace: true });
                    return;
                }

                // Limpia los parámetros code y state de la URL
                window.history.replaceState(
                    {},
                    document.title,
                    "/"
                );

                navigate("/", { replace: true });

            } catch (error) {
                console.error(error);
                navigate("/login", { replace: true });
            }
        };

        processLogin();

    }, [navigate, loginWithOracleCode]);

    return (
        <div className={`wrapper`} >
            <div id='header' className='headerLogin'>
                <img src={logoUrl} alt='Logo' className='logo'></img>
            </div>
            <div className="login-callback-container">
                <div className="login-callback-card">
                    <div className="spinner"></div>

                    <h2>Iniciando sesión</h2>

                    <p>
                        Estamos validando tus credenciales y preparando tu acceso.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default LoginCallback;